import { render, staticRenderFns } from "./LegacyPreview.vue?vue&type=template&id=5390c470&scoped=true&"
import script from "./LegacyPreview.vue?vue&type=script&lang=js&"
export * from "./LegacyPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5390c470",
  null
  
)

export default component.exports